export interface IIdentifiable {
	id?: number;
}

export function isIdentifiable(object: any): object is IIdentifiable {
	return "id" in object;
}
